import { NgModule } from '@angular/core';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
//import { BaseDir } from './layout/core/app-config';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http,'assets/i18n/' , '.json');
}
const translationOptions = {
  provide: TranslateLoader, 
  useFactory: (createTranslateLoader),
  deps: [HttpClient]
};
@NgModule({
  imports: [TranslateModule.forRoot({loader:translationOptions})],
  exports: [TranslateModule]
  // providers: [TranslateService]
})
export class AppTranslationModule {
  constructor() {

  }
  // constructor(private translate: TranslateService) {
  //   translate.addLangs(["en"]);
  //   translate.setDefaultLang('en');
  //   translate.use('en');
  // }
}